// ---------------------------------------------------------------------------
// Query keys (extracted from profile.ts to break the api.ts <-> profile.ts cycle)
// ---------------------------------------------------------------------------

export const userKeys = {
    all: ["user"] as const,
    me: ["user", "me"] as const,
    search: (search: string) => ["user", "search", search] as const,
};
